<app-header></app-header>

<div class="content" role="main">
	<div class="container">
		<div class="row">
			<div id="information" class="col-md-12" >
				<span>{{ 'operatingInfo.title' | translate }}</span><br>
				<span [innerHTML]="'operatingInfo.weekdays' | translate: { value: showTime('weekdays') }"></span><br>
				<span [innerHTML]="'operatingInfo.weekend' | translate: { value: showTime('weekend') }"></span>
			</div>
			<div class="col-md-12" >
				<span >{{ 'Instruction' | translate }}</span>
				<app-form></app-form>
			</div>
		</div>
	</div>
	
</div>

<app-footer></app-footer>

<router-outlet></router-outlet>
